import React from 'react';
import './AboutLoyalTap.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AboutLoyalTap = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="about-container">
      <header className="about-header">
        <h1>{t('aboutPage.title')} <span className="brand-highlight">LoyalTap</span></h1>
        <p>{t('aboutPage.subtitle')}</p>
      </header>

      <section className="about-section">
        <div className="feature-block">
          <h2>{t('aboutPage.trust_title')}</h2>
          <p>{t('aboutPage.trust_text')}</p>
        </div>

        <div className="feature-block">
          <h2>{t('aboutPage.ai_title')}</h2>
          <p>{t('aboutPage.ai_text')}</p>
        </div>

        <div className="feature-block">
          <h2>{t('aboutPage.simple_title')}</h2>
          <p>{t('aboutPage.simple_text')}</p>
        </div>
      </section>

      <section className="privacy-section">
        <h2>{t('aboutPage.privacy_title')}</h2>
        <p>
          {t('aboutPage.privacy_text')}{" "}
          <a href="/privacy-policy" className="policy-link">
            {t('aboutPage.privacy_link')}
          </a>
        </p>
        <button className="back-dashboard" onClick={() => navigate('/dashboard')}>
          {t('aboutPage.back')}
        </button>
      </section>

      <footer className="about-footer">
        <p>
          {t('aboutPage.footer')}{" "}
          <a href="https://flexpayz.com" target="_blank" rel="noopener noreferrer">FlexPayz Technology</a> © {new Date().getFullYear()}.
        </p>
      </footer>
    </div>
  );
};

export default AboutLoyalTap;